import { Component, OnInit, AfterViewInit, Renderer2, ElementRef } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage-service';
declare var google: any;
declare var $: any;

@Component({
    selector: 'app-language',
    templateUrl: './language.component.html',
    styleUrls: ['./language.component.css']
})
export class LanguageComponent implements AfterViewInit {

    language:any='';
    is_default_language:any='';
    curlanguage:any='';
    curdefflanguage:any='';

    constructor(
        private renderer: Renderer2, 
        private el: ElementRef,
        private localStorageService: LocalStorageService,
    ) {
        this.language = this.localStorageService.getItem("project_language");
        this.is_default_language = this.localStorageService.getItem("is_default_language");

        this.curlanguage = this.language.__zone_symbol__value;
        this.curdefflanguage = this.is_default_language.__zone_symbol__value;
      
        console.log('language',this.language);
        console.log('is_default_language',this.is_default_language);

        console.log('language', this.curlanguage);
        console.log('language',this.curdefflanguage);

        if(this.curdefflanguage != null) {
            if(this.curdefflanguage != 'en') {
                if(this.curdefflanguage == '1') {
                    this.defaultLang = this.curlanguage;
                }
                this.languageArr.push(this.curlanguage);
                this.is_translate = true;
                this.loadGoogleTranslate();
            }
        }
    }

    languageArr = ['en'];
    defaultLang: string = '';
    is_translate:boolean = false;

    ngAfterViewInit(): void {
        if (this.defaultLang != '') {
            this.selectDefaultLanguage()
        }
    }

    loadGoogleTranslate(): void {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
        document.body.appendChild(script);

        (window as any).googleTranslateElementInit = () => this.googleTranslateElementInit();
    }

    googleTranslateElementInit(): void {
        new google.translate.TranslateElement({
            pageLanguage: 'en',
            includedLanguages: this.languageArr.join(),
            layout: google.translate.TranslateElement.FloatPosition.TOP_LEFT,
            autoDisplay: false
        }, 'google_translate_element');
        const googleDiv = this.el.nativeElement.querySelector('#google_translate_element .skiptranslate');
        if (googleDiv) {
        const googleDivChild = googleDiv.querySelector('div');
        if (googleDivChild) {
            // Remove the sibling element of the first div
            const nextSibling = googleDivChild.nextElementSibling;
            if (nextSibling) {
            this.renderer.removeChild(googleDiv, nextSibling);
            }

            // Remove text nodes with non-empty values
            googleDiv.childNodes.forEach((node: ChildNode) => {
            if (node.nodeType === Node.TEXT_NODE && (node as Text).nodeValue?.trim() !== '') {
                this.renderer.removeChild(googleDiv, node);
            }
            });
        }
        }
    }

    selectDefaultLanguage(): void {
        const url = new URL(window.location.href);
        url.hash = `googtrans(en|${this.defaultLang})`;
        window.history.pushState({}, '', url.toString());
    }
}